var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#5364FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6832 25.9375H27.7207H21.8832V29.475H23.5207H28.6832C29.8707 29.475 30.8457 28.675 30.8457 27.7C30.8457 26.725 29.8707 25.9375 28.6832 25.9375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9707 12.5C18.0707 12.5 12.4707 18.1 12.4707 25C12.4707 31.9 18.0707 37.5 24.9707 37.5C31.8707 37.5 37.4707 31.9 37.4707 25C37.4707 18.1 31.8707 12.5 24.9707 12.5ZM28.6832 31.35H26.6207V33.125C26.6207 33.6375 26.1957 34.0625 25.6832 34.0625C25.1707 34.0625 24.7457 33.6375 24.7457 33.125V31.35H23.5207H23.2332V33.125C23.2332 33.6375 22.8082 34.0625 22.2957 34.0625C21.7832 34.0625 21.3582 33.6375 21.3582 33.125V31.35H20.9457H18.7832C18.2707 31.35 17.8457 30.925 17.8457 30.4125C17.8457 29.9 18.2707 29.475 18.7832 29.475H20.0082V25V20.525H18.7832C18.2707 20.525 17.8457 20.1 17.8457 19.5875C17.8457 19.075 18.2707 18.65 18.7832 18.65H20.9457H21.3582V16.875C21.3582 16.3625 21.7832 15.9375 22.2957 15.9375C22.8082 15.9375 23.2332 16.3625 23.2332 16.875V18.65H23.5207H24.7457V16.875C24.7457 16.3625 25.1707 15.9375 25.6832 15.9375C26.1957 15.9375 26.6207 16.3625 26.6207 16.875V18.65H27.7207C29.6582 18.65 31.3707 20.35 31.3707 22.3C31.3707 23.1375 31.0707 23.9 30.5957 24.525C31.8582 25.1375 32.7207 26.3375 32.7207 27.725C32.7207 29.7125 30.9082 31.35 28.6832 31.35Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4957 22.2877C29.4957 21.4627 28.7207 20.5127 27.7207 20.5127H23.5207H21.8832V24.0502H27.7207C28.6957 24.0627 29.4957 23.2627 29.4957 22.2877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrypto);
export default __webpack_public_path__ + "static/media/icon_crypto.649ffd039c743bbb14aa39b23414f323.svg";
export { ForwardRef as ReactComponent };